import Filter from "../../../../helpers/Filter";

const convertToRaw = (configuations, ownerId) => {
    const convertParams = {
        "Tax 1": Filter.changeToNameSettingsByOwner("tax1", "Tax 1", false, ownerId),
        "Tax 2": Filter.changeToNameSettingsByOwner("tax2", "Tax 2", false, ownerId),
        "Tax Before Discount": Filter.changeToNameSettingsByOwner("taxBeforeDiscount", "Tax Before Discount", true, ownerId),
        "Tax Before": Filter.changeToNameSettingsByOwner("taxBeforeDiscount", "Tax Before", false, ownerId),
        "Net Tax Before Discount": Filter.changeToNameSettingsByOwner("netTaxBeforeDiscount", "Net Tax Before Discount", false, ownerId),
    };
    if(!Filter.isJSONToStringtify(configuations)) {
        return configuations;
    }
    let strConfiguations = JSON.stringify(configuations);
    const replaceObjs = Object.keys(convertParams);
    for(let i = 0; i < replaceObjs.length; i++) {
        const replaceStr = replaceObjs[i];
        if(replaceStr == undefined) {
            continue;
        }
        const searchStr = convertParams[replaceStr];
        if(searchStr == undefined) {
            continue;
        }
        strConfiguations = strConfiguations.replace(new RegExp(searchStr, 'g'), replaceStr);
    }
    const result = JSON.parse(strConfiguations);
    return {
       ...result
    }
}

const convertToAfterProgress = (configuations, ownerId) => {
    const convertParams = {
        "Tax 1": Filter.changeToNameSettingsByOwner("tax1", "Tax 1", false, ownerId),
        "Tax 2": Filter.changeToNameSettingsByOwner("tax2", "Tax 2", false, ownerId),
        "Tax Before Discount": Filter.changeToNameSettingsByOwner("taxBeforeDiscount", "Tax Before Discount", true, ownerId),
        "Tax Before": Filter.changeToNameSettingsByOwner("taxBeforeDiscount", "Tax Before", false, ownerId),
        "Net Tax Before Discount": Filter.changeToNameSettingsByOwner("netTaxBeforeDiscount", "Net Tax Before Discount", false, ownerId),
    };
    if(!Filter.isJSONToStringtify(configuations)) {
        return configuations;
    }
    let strConfiguations = JSON.stringify(configuations);
    const replaceObjs = Object.keys(convertParams);
    for(let i = 0; i < replaceObjs.length; i++) {
        const searchStr = replaceObjs[i];
        if(searchStr == undefined) {
            continue;
        }
        const replaceStr = convertParams[searchStr];
        if(replaceStr == undefined) {
            continue;
        }
        strConfiguations = strConfiguations.replace(new RegExp(searchStr, 'g'), replaceStr);
    }
    const result = JSON.parse(strConfiguations);
    return {
       ...result
    }
}

export default {
    convertToRaw: convertToRaw,
    convertToAfterProgress: convertToAfterProgress
};